export default interface IZoningFilter {
    name: string;
    geoid: string;
    municipality: string | null;
    zonings: string[];
    color: ZoningFilterColor;
}

export enum ZoningFilterColor {
    Normal = "Normal",
    Light = "Light",
}